import React from "react";
import PropTypes from "prop-types";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import ViewIcon from "@material-ui/icons/Visibility";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import NotificationAddIcon from "@material-ui/icons/AddAlert";
import AppSettingsIcon from "@material-ui/icons/PhoneAndroid";
const useStyles = makeStyles(theme => ({
  select: {
    fontSize: "0.75rem"
  },
  formControl: {
    minWidth: 120,
    maxWidth: 300,
    margin: "0px",
    marginTop: "16px"
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    lineHeight: 1,
    transform: "translate(0, 1.5px) scale(0.75)",
    transformOrigin: "top left",
    letterSpacing: "0.00938em",
    transition:
      "color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms"
  }
}));

const RelatedContact = ({
  onChange,
  disabled,
  error,
  title,
  related_contact,
  subcontacts,
  subcontact_relation_types,
  addNewItem,
  removeItem,
  is_fleet_owner,
  ...props
}) => {
  const has_car_doc_documents = [
    { id: 0, name: "No" },
    { id: 1, name: "Si" }
  ];

  const handleChange = event => {
    onChange(event, "related_contact");
  };

  const classes = useStyles();

  const handleAddItem = event => {
    event.preventDefault();
    event.stopPropagation();
    addNewItem("subcontact_ids");
  };

  const handleRemoveItem = (event, idx) => {
    event.preventDefault();
    event.stopPropagation();
    removeItem("subcontact_ids", idx);
  };

  const getSubcontactData = id => {
    if (id !== "" && id !== undefined && id !== null) {
      var data = { id: id };
      subcontacts.map((val, idx) => {
        if (parseInt(val.id) === parseInt(id)) {
          data.firstname = val.firstname;
          data.lastname = val.lastname;
          data.email = val.contact.email;
          data.license_due_date = val.license_due_date;
          data.id = val.id;
          data.user_id = val.user_id;
        }
      });
    }

    return data;
  };

  var has_driver = false;

  related_contact.subcontact_ids.map((val, idx) => {
    if (
      related_contact.subcontact_ids[idx].relation_type_id === "2" ||
      related_contact.subcontact_ids[idx].relation_type_id === 2
    ) {
      has_driver = true;
    }
  });
  return (
    <React.Fragment>
      <Typography variant="h6" className="mt-2">
        {title}
      </Typography>
      {related_contact.subcontact_ids.map((val, idx) => {
        var data = "";
        if (
          related_contact.subcontact_ids[idx].subcontact_id !== "" &&
          related_contact.subcontact_ids[idx].subcontact_id !== null &&
          related_contact.subcontact_ids[idx].subcontact_id !== undefined
        ) {
          data = getSubcontactData(
            related_contact.subcontact_ids[idx].subcontact_id
          );
        }

        if (related_contact.subcontact_ids[idx].relation_type_id === "2") {
          has_driver = true;
        }
        return (
          <React.Fragment>
            <div className="row ml-1">
              <FormControl
                className="mt-3 mr-2"
                style={{ minWidth: 100, fontSize: "0.75rem" }}
                name={"relation_type_id." + idx}
              >
                <InputLabel
                  htmlFor="grouped-native-select"
                  autoWidth="true"
                  style={{ minWidth: 100, fontSize: "0.75rem" }}
                >
                  Seleccione relación
                </InputLabel>
                <Select
                  native
                  name={"relation_type_id." + idx}
                  inputProps={{
                    name: "relation_type_id." + idx,
                    className: "relation_type_id." + idx
                  }}
                  style={{ minWidth: 80, fontSize: "0.75rem" }}
                  disabled={disabled}
                  onChange={handleChange}
                  error={
                    error !== "" &&
                    parseInt(is_fleet_owner) !== 1 &&
                    related_contact.subcontact_ids[idx].relation_type_id === ""
                      ? "Debe completar este campo"
                      : false
                  }
                  value={related_contact.subcontact_ids[idx].relation_type_id}
                  input={
                    <Input
                      id="grouped-native-select"
                      name={"relation_type_id." + idx}
                    />
                  }
                >
                  <option value="" />
                  {subcontact_relation_types.map(relation_type => (
                    <option id={relation_type.id} value={relation_type.id}>
                      {relation_type.name}
                    </option>
                  ))}
                </Select>
                {error !== "" &&
                  parseInt(is_fleet_owner) !== 1 &&
                  related_contact.subcontact_ids[idx].relation_type_id ===
                    "" && (
                    <FormHelperText style={{ color: "red" }}>
                      Debe completar este campo
                    </FormHelperText>
                  )}
                {error !== "" &&
                  parseInt(is_fleet_owner) !== 1 &&
                  has_driver === false && (
                    <FormHelperText style={{ color: "red" }}>
                      Debe haber al menos un conductor
                    </FormHelperText>
                  )}
              </FormControl>

              {related_contact.subcontact_ids[idx].id ? (
                <TextField
                  id={"name" + idx}
                  name={"name" + idx}
                  label="Conductor"
                  disabled={true}
                  type="text"
                  value={val.firstname + " " + val.lastname}
                  margin="normal"
                  className="mr-1"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { fontSize: "0.75rem" } }}
                />
              ) : (
                <FormControl
                  className="mt-3 mr-2"
                  style={{ minWidth: 150, fontSize: "0.75rem" }}
                  name={"subcontact_id." + idx}
                >
                  <InputLabel
                    htmlFor="grouped-native-select"
                    autoWidth="true"
                    style={{ minWidth: 150, fontSize: "0.75rem" }}
                  >
                    Subcontacto
                  </InputLabel>
                  <Select
                    native
                    name={"subcontact_id." + idx}
                    inputProps={{
                      name: "subcontact_id." + idx,
                      className: "subcontact_id." + idx
                    }}
                    style={{ minWidth: 100, fontSize: "0.75rem" }}
                    disabled={disabled}
                    onChange={handleChange}
                    error={
                      error !== "" &&
                      parseInt(is_fleet_owner) !== 1 &&
                      related_contact.subcontact_ids[idx].subcontact_id === ""
                        ? "Debe completar este campo"
                        : false
                    }
                    value={related_contact.subcontact_ids[idx].subcontact_id}
                    input={
                      <Input
                        id="grouped-native-select"
                        name={"subcontact_id." + idx}
                      />
                    }
                  >
                    <option value="" />
                    {subcontacts.map(subcontact => (
                      <option id={subcontact.id} value={subcontact.id}>
                        {subcontact.lastname + " " + subcontact.firstname}
                      </option>
                    ))}
                  </Select>
                  {error !== "" &&
                    parseInt(is_fleet_owner) !== 1 &&
                    related_contact.subcontact_ids[idx].subcontact_id ===
                      "" && (
                      <FormHelperText style={{ color: "red" }}>
                        Debe completar este campo
                      </FormHelperText>
                    )}
                </FormControl>
              )}
              {data.id ? (
                <ViewIcon
                  className="my-auto mx-2"
                  fontSize="small"
                  onClick={e => {
                    window.open("/subcontacts/subcontact/" + data.id, "_blank");
                  }}
                />
              ) : (
                ""
              )}
              {data !== "" ? (
                <React.Fragment>
                  <TextField
                    id={"name" + idx}
                    name={"name" + idx}
                    label="Nombre"
                    disabled={true}
                    type="text"
                    value={data.firstname}
                    margin="normal"
                    className="mr-1"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{ style: { fontSize: "0.75rem" } }}
                  />

                  <TextField
                    id={"lastname" + idx}
                    name={"lastname" + idx}
                    label="Apellido"
                    disabled={true}
                    type="text"
                    value={data.lastname}
                    margin="normal"
                    className="mr-1"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{ style: { fontSize: "0.75rem" } }}
                  />

                  <TextField
                    id={"email" + idx}
                    name={"email" + idx}
                    label="Mail"
                    disabled={true}
                    type="text"
                    value={data.email}
                    margin="normal"
                    className="mr-1"
                    InputLabelProps={{
                      shrink: true
                    }}
                    inputProps={{ style: { fontSize: "0.75rem" } }}
                  />
                  {parseInt(
                    related_contact.subcontact_ids[idx].relation_type_id
                  ) === 2 ? (
                    <React.Fragment>
                      <TextField
                        id={"start_date." + idx}
                        name={"start_date." + idx}
                        label="Fecha de inicio"
                        type="date"
                        disabled={disabled}
                        onChange={handleChange}
                        value={related_contact.subcontact_ids[idx].start_date}
                        error={
                          error !== "" &&
                          related_contact.subcontact_ids[idx].start_date === ""
                            ? "Debe completar este campo"
                            : false
                        }
                        helperText={
                          error !== "" &&
                          related_contact.subcontact_ids[idx].start_date === ""
                            ? "Debe completar este valor"
                            : ""
                        }
                        margin="normal"
                        className="mr-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{ style: { fontSize: "0.75rem" } }}
                      />
                      <TextField
                        id={"end_date." + idx}
                        name={"end_date." + idx}
                        label="Fecha fin"
                        type="date"
                        onChange={handleChange}
                        disabled={disabled}
                        value={related_contact.subcontact_ids[idx].end_date}
                        margin="normal"
                        className="mr-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{ style: { fontSize: "0.75rem" } }}
                      />
                      <FormControl
                        className="mt-3 mr-2"
                        style={{ minWidth: 115, fontSize: "0.75rem" }}
                        name="has_car_doc_documents"
                      >
                        <InputLabel
                          htmlFor="grouped-native-select"
                          autoWidth="true"
                          style={{ fontSize: "0.75rem" }}
                        >
                          {" "}
                          Autorización Manejo / Cedula Azul
                        </InputLabel>
                        <Select
                          native
                          name="has_car_doc_documents"
                          inputProps={{
                            name: "has_car_doc_documents." + idx,
                            className: "has_car_doc_documents." + idx
                          }}
                          style={{ fontSize: "0.75rem" }}
                          disabled={disabled}
                          onChange={handleChange}
                          required
                          error={
                            error !== "" &&
                            related_contact.subcontact_ids[idx]
                              .has_car_doc_documents === ""
                              ? "Debe completar este campo"
                              : false
                          }
                          value={
                            related_contact.subcontact_ids[idx]
                              .has_car_doc_documents
                          }
                          input={
                            <Input
                              id="grouped-native-select"
                              name="has_car_doc_documents"
                            />
                          }
                        >
                          <option value="" />
                          {has_car_doc_documents.map(has_car_doc_document => (
                            <option
                              id={has_car_doc_document.id}
                              value={has_car_doc_document.id}
                            >
                              {has_car_doc_document.name}
                            </option>
                          ))}
                        </Select>
                        {error !== "" &&
                          related_contact.subcontact_ids[idx]
                            .has_car_doc_documents === "" && (
                            <FormHelperText style={{ color: "red" }}>
                              Debe completar este campo
                            </FormHelperText>
                          )}
                      </FormControl>
                      {parseInt(
                        related_contact.subcontact_ids[idx]
                          .has_car_doc_documents
                      ) === 1 ? (
                        <React.Fragment>
                          {/*<TextField
                                id={"car_doc_documents_due_date."+idx}
                                name={"car_doc_documents_due_date."+idx}
                                label="Fecha vencimiento cedula"
                                type="date"
                                onChange={handleChange}
                                disabled={disabled}
                                required
                                value={related_contact.subcontact_ids[idx].car_doc_documents_due_date}
                                margin="normal"
                                className="mr-1"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                inputProps={{style:{minWidth: 150,fontSize: '0.75rem'}}} 
                              />
                              <TextField
                                id={"car_doc_document_number."+idx}
                                name={"car_doc_document_number."+idx}
                                label="Nro cedula azul"
                                type="integer"
                                onChange={handleChange}
                                disabled={disabled}
                                value={related_contact.subcontact_ids[idx].car_doc_document_number}
                                margin="normal"
                                className="mr-1"
                                InputLabelProps={{
                                  shrink: true
                                }}
                                inputProps={{style:{fontSize: '0.75rem'}}} 
                              />*/}
                        </React.Fragment>
                      ) : (
                        ""
                      )}
                      <TextField
                        id={"license_due_date." + idx}
                        name={"license_due_date." + idx}
                        label="Vencimiento Lic"
                        type="date"
                        //onChange={handleChange}
                        disabled={true}
                        value={data.license_due_date}
                        margin="normal"
                        className="mr-1"
                        InputLabelProps={{
                          shrink: true
                        }}
                        inputProps={{ style: { fontSize: "0.75rem" } }}
                      />
                    </React.Fragment>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              ) : (
                ""
              )}

              <div
                class="mt-4"
                style={{ width: "min-content", display: "inline-flex" }}
              >
                <IconButton
                  size="small"
                  className={classes.iconButton}
                  onClick={e => {
                    handleRemoveItem(e, idx);
                  }}
                  disabled={
                    disabled || related_contact.subcontact_ids.length == 1
                      ? true
                      : false
                  }
                >
                  <RemoveIcon
                    disabled={disabled}
                    className={classes.deleteIcon}
                  />
                </IconButton>
                <IconButton
                  disabled={disabled}
                  size="small"
                  className={classes.iconButton}
                  onClick={e => {
                    handleAddItem(e);
                  }}
                >
                  <AddIcon disabled={disabled} className={classes.deleteIcon} />
                </IconButton>
                <IconButton
                  size="small"
                  className={classes.iconButton}
                  onClick={e => {
                    window.open("/mobile/user/" + data.id, "_blank");
                  }}
                  disabled={disabled}
                >
                  <AppSettingsIcon
                    disabled={disabled}
                    className={classes.deleteIcon}
                  />
                </IconButton>
                {data.user_id ? (
                  <IconButton
                    size="small"
                    className={classes.iconButton}
                    onClick={e => {
                      window.open(
                        "/push/notification/" + data.user_id,
                        "_blank"
                      );
                    }}
                    disabled={disabled}
                  >
                    <NotificationAddIcon
                      disabled={disabled}
                      className={classes.deleteIcon}
                    />
                  </IconButton>
                ) : (
                  ""
                )}
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </React.Fragment>
  );
};
export default RelatedContact;
